export const NO_PRODUCTION_MONITORING_ACCESS = 'production_monitoring_no_access';
export const NO_ACCESS_MESSAGE = 'errors.login.access_denied_no_access';
export const NO_ACCESS_NOTIFICATION_KEY = 'production-monitoring-no-access';

export const isProductionMonitoringAccessDenied = (error: unknown): boolean => {
  const response = (error as { response?: { status?: number; data?: { code?: string } } })?.response;
  return response?.status === 403 && response.data?.code === NO_PRODUCTION_MONITORING_ACCESS;
};
